import { store } from '@/store'
import { ModuleName } from '@/store/modules/createWarehouseReceivingOrder'
import { VALID_NEXT_TRANSITION_NAME, NEXT_TRANSITION_NAME, HISTORY_TRANSITION_NAME } from '@/models/createWarehouseReceivingOrder/build-state-node'
import { machine, computeStepIndex } from '@/models/createWarehouseReceivingOrder/create-order-machine'

export const setState = (stepName) => (_state, _draft) => store.dispatch(ModuleName + '/setState', stepName)

export const completeStep = (stepNumber) => (_state, _draft) => {
  if (store._modules.root._children[ModuleName]) store.dispatch(ModuleName + '/completeStep', stepNumber)
}

export const saveWro = ({ mapper, service }) => async (_state, draft) => {
  const furthestCompletedStep = draft.furthestCompletedStep
  const stepNumber = computeStepIndex(draft.currentStep)
  const res = !draft.wroCreated
    ? await store.dispatch(ModuleName + '/upsertWro', { mapper, service, draft })
    : { success: true, response: draft }
  if (res.success) {
    if (machine.visited.has(stepNumber + 1)) {
      machine.transition(HISTORY_TRANSITION_NAME)
    } else if (stepNumber < furthestCompletedStep) {
      machine.transition(VALID_NEXT_TRANSITION_NAME)
    } else {
      machine.transition(NEXT_TRANSITION_NAME)
    }
  } else {
    machine.transition('SAVE_FAIL')
  }
  return res
}
